var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOutlineEventNote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 4.2821H18.5V2.2821H16.5V4.2821H8.5V2.2821H6.5V4.2821H5.5C4.4 4.2821 3.5 5.1821 3.5 6.2821V20.2821C3.5 21.3821 4.4 22.2821 5.5 22.2821H19.5C20.6 22.2821 21.5 21.3821 21.5 20.2821V6.2821C21.5 5.1821 20.6 4.2821 19.5 4.2821ZM19.5 20.2821H5.5V10.2821H19.5V20.2821ZM5.5 8.2821V6.2821H19.5V8.2821H5.5ZM7.5 12.2821H17.5V14.2821H7.5V12.2821ZM7.5 16.2821H14.5V18.2821H7.5V16.2821Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineEventNote);
export default __webpack_public_path__ + "static/media/outline-event-note.48e08d82d2bb5a18bb9291d261a0abcb.svg";
export { ForwardRef as ReactComponent };